import { FC, useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa6';
import { useMediaQuery } from '@mui/material';
import { TableContainer, SearchBar, ErrorType, TableVersion, FilterCarousel, DashboardDrawerForm } from '..';
import OperationCenterErrorCard from '../OperationCenterErrorCard/OperationCenterErrorCard';
import type { TableWithSearchFilterTemplatePropsTypes, UserData } from './types/propsTypes';
import styles from './TableWithSearchFilterTemplate.module.scss';

const TableWithSearchFilterTemplate: FC<TableWithSearchFilterTemplatePropsTypes> = ({
  dataSource,
  onRowClick,
  handleSearch = () => {},
  handleReset = () => {},
  tempFilterList,
  filterList,
  hideAddButton = false,
  children = null,
  searchKey,
  onToggleFilterOpen = () => {},
  onToggleOptionChecked = () => {},
  handleApplyChanges = () => {},
  onClose = () => {},
  handleResetFilters = () => {},
  hideSearchFilter = false,
  pagination = true,
  placeholder,
  ...rest
}: TableWithSearchFilterTemplatePropsTypes): JSX.Element => {
  const [filteredData, setFilteredData] = useState<UserData[]>(dataSource);
  const [noResults, setNoResults] = useState<boolean>(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    setFilteredData(dataSource);
    setNoResults(dataSource.length === 0);
  }, [dataSource]);

  const cards = tempFilterList?.map((i, index) => {
    return (
      <div
        className={`${styles['filter-item']} ${filterList?.[index].filterOptions.some((i) => i.checked) ? styles['checked'] : ''}`}
        onClick={() => onToggleFilterOpen(index)}
      >
        <div>{i.filterName}</div> <FaChevronDown color={'#6B7280'} />
      </div>
    );
  });

  return (
    <div className={styles['table-with-search-filter-container']}>
      {!hideSearchFilter && <><div className={styles['search']}>
        <SearchBar
          placeholder={placeholder}
          onSearch={handleSearch}
          handleReset={handleReset}
          initialSearchText={searchKey}
        />
      </div>

      <div className={styles['filter']}>
        <FilterCarousel cards={cards} isMobile={isMobile} />
      </div>

      <div className={styles['reset']} onClick={handleResetFilters}>
        Reset
      </div></>}
      
      {noResults ? (
        <div className={styles['no-results-container']}>
          <OperationCenterErrorCard errorType={ErrorType.NO_RESULT} />
        </div>
      ) : (
        <>
          {children}
          {filteredData?.length > 0 && (
            <TableContainer
              dataSource={filteredData}
              onRowClick={onRowClick}
              pagination={pagination}
              searchKey={searchKey}
              tableVersion={TableVersion.DASHBOARD}
              hideSearchFilter={hideSearchFilter}
              {...rest}
            />
          )}
        </>
      )}

      {tempFilterList?.map((i, index) => (
        <DashboardDrawerForm
          key={index}
          open={i.isOpen}
          title={i.filterName}
          filterIndex={index}
          buttonLabel={'Apply Changes'}
          checkBoxOptions={i.filterOptions}
          onToggleOptionChecked={onToggleOptionChecked}
          onToggleFilterOpen={onToggleFilterOpen}
          onClose={onClose}
          handleApplyChanges={handleApplyChanges}
        />
      ))}
    </div>
  );
};

export default TableWithSearchFilterTemplate;
export type { TableWithSearchFilterTemplatePropsTypes };
